var $9w1Q4$reactjsxruntime = require("react/jsx-runtime");
var $9w1Q4$react = require("react");


function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $03b515f3f8c77d8f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "LazyBackgroundImage", () => $6e38eea936045ca0$export$2e2bcd8739ae039);
$parcel$export(module.exports, "LazyImage", () => $f6f596272f209e0c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "LazyFrame", () => $8e3d626f2d1eebd8$export$2e2bcd8739ae039);
$parcel$export(module.exports, "LazyComponent", () => $c17687259f8b5ddf$export$2e2bcd8739ae039);



function $6e38eea936045ca0$export$2e2bcd8739ae039(props) {
    const [setRef, link, isViewable] = (0, $03b515f3f8c77d8f$export$2e2bcd8739ae039)(props);
    const [style, setStyle] = (0, $9w1Q4$react.useState)({
        backgroundImage: `url(${link})`,
        ...props.style
    });
    (0, $9w1Q4$react.useEffect)(()=>{
        isViewable && setStyle({
            backgroundImage: `url(${link})`,
            ...props.style
        });
    }, [
        link,
        isViewable,
        props.style
    ]);
    return /*#__PURE__*/ (0, $9w1Q4$reactjsxruntime.jsx)("div", {
        className: props.className,
        style: style,
        ref: (node)=>{
            setRef(node);
        },
        children: props.children
    });
}




function $f6f596272f209e0c$export$2e2bcd8739ae039(props) {
    const [setRef, link] = (0, $03b515f3f8c77d8f$export$2e2bcd8739ae039)(props);
    return /*#__PURE__*/ (0, $9w1Q4$reactjsxruntime.jsx)("div", {
        ref: (node)=>{
            setRef(node);
        },
        children: /*#__PURE__*/ (0, $9w1Q4$reactjsxruntime.jsx)("img", {
            src: link,
            alt: props.alt,
            style: props.style,
            className: props.className,
            title: props.title
        })
    });
}




function $8e3d626f2d1eebd8$export$2e2bcd8739ae039(props) {
    const [setRef, link] = (0, $03b515f3f8c77d8f$export$2e2bcd8739ae039)(props);
    return /*#__PURE__*/ (0, $9w1Q4$reactjsxruntime.jsx)("iframe", {
        // scrolling={props.scrolling || 'no'}
        src: link,
        // frameBorder={props.frameBorder || 'no'}
        // style={props.style || {border: props.frameBorder}}
        ref: (node)=>{
            setRef(node);
        },
        ...props,
        height: props.height || '500',
        allowFullScreen: props.allowFullScreen || true
    });
}




function $c17687259f8b5ddf$export$2e2bcd8739ae039(props) {
    const [setRef, _, isVisible] = (0, $03b515f3f8c77d8f$export$2e2bcd8739ae039)(props);
    if (!isVisible) return /*#__PURE__*/ (0, $9w1Q4$reactjsxruntime.jsx)("div", {
        ref: (node)=>{
            setRef(node);
        },
        style: {
            height: '300px',
            width: '300px',
            ...props.style
        }
    });
    return /*#__PURE__*/ (0, $9w1Q4$reactjsxruntime.jsx)("div", {
        children: props.children
    });
}



// array with all the elements that are waiting to be shown in the viewport
const $03b515f3f8c77d8f$var$elements = new Set();
const $03b515f3f8c77d8f$var$CheckIfRender = {
    // top: the position of the element in relation with the top of the browser
    // left: the position of the element in relation with the left of the browser
    // offset: the desired offset of the element in relation of the viewport
    isInViewPort: ({ offset: offset, top: top, left: left })=>top < window.innerHeight + offset && left < window.innerWidth + offset,
    calculateNewPosition: (elem)=>{
        const { top: top, left: left } = elem.element?.getBoundingClientRect() || {
            top: 0,
            left: 0
        };
        return {
            ...elem,
            top: top,
            left: left
        };
    },
    addElement: (element)=>{
        //the distance from the pixel 0,0 and the top of the element
        $03b515f3f8c77d8f$var$elements.add(element);
        //check if has already been started the rAF cycle
        if ($03b515f3f8c77d8f$var$CheckIfRender.isListenerAttached === 0) $03b515f3f8c77d8f$var$CheckIfRender.isListenerAttached = window.requestAnimationFrame($03b515f3f8c77d8f$var$CheckIfRender.eventHandler);
    },
    eventHandler: ()=>{
        //if there is no more element to lazy load remove the listener/rAF
        if ($03b515f3f8c77d8f$var$elements.size === 0) $03b515f3f8c77d8f$var$CheckIfRender.removeScrollHandler();
        else {
            $03b515f3f8c77d8f$var$elements.forEach((elem)=>{
                const haveToShow = $03b515f3f8c77d8f$var$CheckIfRender.isInViewPort($03b515f3f8c77d8f$var$CheckIfRender.calculateNewPosition(elem));
                if (haveToShow) {
                    elem.makeItVisible();
                    // remove element from the list of elements to lazy load
                    $03b515f3f8c77d8f$var$CheckIfRender.removeElementFromList(elem);
                }
            });
            $03b515f3f8c77d8f$var$CheckIfRender.isListenerAttached = window.requestAnimationFrame($03b515f3f8c77d8f$var$CheckIfRender.eventHandler);
        }
    },
    removeScrollHandler: ()=>{
        window.cancelAnimationFrame($03b515f3f8c77d8f$var$CheckIfRender.isListenerAttached);
        $03b515f3f8c77d8f$var$CheckIfRender.isListenerAttached = 0;
    },
    //When an element is unloaded remove it from the list of elements that are waiting to be lazy-loaded
    removeElementFromList: (toRemove)=>{
        $03b515f3f8c77d8f$var$elements.delete(toRemove);
    },
    isListenerAttached: 0
};
function $03b515f3f8c77d8f$export$2e2bcd8739ae039(props) {
    const [link, setLink] = (0, $9w1Q4$react.useState)('');
    const [visible, setVisible] = (0, $9w1Q4$react.useState)(false);
    const [ref, setRef] = (0, $9w1Q4$react.useState)(null);
    const makeItVisible = (0, $9w1Q4$react.useCallback)(()=>{
        if (props.link) setLink(()=>props.link);
        setVisible(()=>true);
    }, [
        props.link
    ]);
    const thisInstance = (0, $9w1Q4$react.useMemo)(()=>{
        return {
            element: ref,
            makeItVisible: makeItVisible,
            offset: props.offset || 100
        };
    }, [
        ref,
        props.offset,
        makeItVisible
    ]);
    const getRef = (0, $9w1Q4$react.useCallback)((node)=>{
        if (node !== null) setRef(node);
    }, []);
    (0, $9w1Q4$react.useEffect)(()=>{
        if (ref !== null) // add the element to the array of elements that are waiting to be lazy loaded
        $03b515f3f8c77d8f$var$CheckIfRender.addElement(thisInstance);
        return ()=>// if the element is unloaded remove the element from the list of elements that needs to be lazy loader
            $03b515f3f8c77d8f$var$CheckIfRender.removeElementFromList(thisInstance);
    }, [
        ref,
        thisInstance
    ]);
    return [
        getRef,
        link,
        visible
    ];
}




//# sourceMappingURL=index.js.map
